module.exports = __webpack_public_path__ + "img/mpf.9202c17.webp";